module.exports = __webpack_public_path__ + "static/media/menu-administration.e59f3877.svg";